import axios from "axios";
import {toaster} from "evergreen-ui";
import {hostWithPrefix} from "../common/ApiCommon";

export function generateTTExcel(period, constructorData, name) {
    const template = {
        station: constructorData.station.id,
        type: 'TT',
        stationName: constructorData.station.name,
        filters: constructorData.filtersRows.map((row) => {
            return {
                type: {
                    id: row.type.id,
                    name: row.type.name
                },
                stnEntity: {
                    id: row.stnEntity.id,
                    name: row.stnEntity.name,
                    valueParamsString: row.stnEntity.valueParamsString
                },
                code: row.code
            }
        }),
        tableOperations: constructorData.tableOperations.map(operation => operation.code)
    }

    const req = {
        name: name,
        period: period,
        template: template
    }

    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/temporary_turn', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
    });
}

export function createTemplate(constructorData, templateName) {
    const req = {
        station: constructorData.station.id,
        type: constructorData.type,
        name: templateName,
        tableOperations: constructorData.tableOperations.map(operation => operation.code),
        filters: constructorData.filtersRows.map((row) => {
            return {
                type: {
                    id: row.type.id,
                    name: row.type.name
                },
                stnEntity: {
                    id: row.stnEntity.id,
                    name: row.stnEntity.name,
                    valueParamsString: row.stnEntity.valueParamsString
                },
                code: row.code,
            }
        })
    }

    axios({
        url: 'http://' + hostWithPrefix + '/templates/tt', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
    }).then((response) => {
        toaster.success('Шаблон сохранён!')
    }).catch((err) => {
        if (err.response.status === 400) {
            toaster.danger("Некорректный запрос! Возможно шаблон с таким именем уже существует.")
        } else {
            toaster.danger("Не получилось!")
        }
    });

}